import { useEffect, useRef, useState } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';

export default function StatCounter({ value, suffix = '', text, label, note, dark = false }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-40px' });
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(0);
  const numeric = typeof value === 'number';

  useEffect(() => {
    if (!inView || !numeric) return;
    if (reduce) { setDisplay(value); return; }
    const duration = 1400;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, numeric, reduce]);

  return (
    <div ref={ref} className="group" data-testid={`stat-${(label || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
      <div className={`font-heading text-4xl font-extrabold tracking-tight sm:text-5xl ${dark ? 'text-white' : 'text-brand-black'}`}>
        {numeric ? <>{display}<span className="text-brand-green">{suffix}</span></> : <span className="text-2xl sm:text-3xl">{text}</span>}
      </div>
      <div className={`mt-3 text-sm font-semibold ${dark ? 'text-white/90' : 'text-brand-black'}`}>{label}</div>
      <div className={`mt-1 text-xs leading-relaxed ${dark ? 'text-white/50' : 'text-brand-body'}`}>{note}</div>
      <div className="mt-4 h-px w-10 bg-brand-green transition-all duration-500 group-hover:w-16" />
    </div>
  );
}
